<template lang="">
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 53.66 53.66">
    <g id="Calculate_Payment" data-name="Calculate Payment" transform="translate(-917.53 -307.996)">
      <circle id="Ellipse_1081" data-name="Ellipse 1081" cx="26.33" cy="26.33" r="26.33" transform="translate(918.03 308.496)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <path id="Path_69786" data-name="Path 69786" d="M34.019,15.736,44.239,25.956a1.067,1.067,0,0,0,1.507,0L57.473,14.229a1.07,1.07,0,0,0,.312-.754V3.256A1.066,1.066,0,0,0,56.719,2.19H46.5a1.065,1.065,0,0,0-.754.312L34.019,14.229A1.065,1.065,0,0,0,34.019,15.736Z" transform="translate(897.347 321.825)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <circle id="Ellipse_970" data-name="Ellipse 970" cx="1.605" cy="1.605" r="1.605" transform="translate(948.212 327.724)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    </g>
  </svg>

  </div>
</template>
<script>
export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    height: {
      type: String,
      required: false,
      default: '53.66px',
    },
    width: {
      type: String,
      required: false,
      default: '53.66px',
    },
  },
}
</script>
<style lang="">

</style>
